import request from "@utils/request";

export function getLPPositionRec(query) {
    return request({
        url: 'lp/position-rec',
        method: 'get',
        params: query
    })
}
